
export function reorient() {
    const positionLastShown = Number(sessionStorage.getItem('positionLastShown'))
    let position = history.state // Absolute position in stack
    // Meaning a new entry on the stack
    if (position === null) {
        position = positionLastShown + 1 // Top of stack

        // (1) Stamp the entry with its own position in the stack
        history.replaceState(position, '')
    }

    // (2) Keep track of the last position shown
    sessionStorage.setItem('positionLastShown', String(position))

    // (3) Discover the direction of travel by comparing the two
    // One of backward (-1), reload (0) or forward (1)
    return position - positionLastShown
}
